import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { ConfirmState } from './types';

const initState = () => {
    return new ConfirmState();
};

export const useConfirmModule = createStoreModule<ConfirmState, IAction<ConfirmState>>(initState, 'app-confirm');
